/**
 * Vue Component Form validation: Enabled for v-select and VueBootstrap
 * @author Daniel Silveira <daniel@dssn.com.br>
 **/

export default {

    props: [''],

    data: () => { return {
        activeForms: null,
    }},

    mounted: function(){

        let submitButton = this.$el.querySelector('button[type=submit]');

        if (submitButton === null) {
            return;
        }

        submitButton.addEventListener('click', function(e){
            if (!this.formIsValid()) {
                e.preventDefault();
                return;
            }

            console.log('form sent!');
        }.bind(this))

    },

    methods: {

        formIsValid: function(formElement, errorsArray) {

            let defaultErrorsArray = [];
                defaultErrorsArray['empty'] = 'Não pode ficar em branco';
                defaultErrorsArray['email'] = 'Email inválido';
                defaultErrorsArray['missmatch'] = 'Campos não estão iguais';
                defaultErrorsArray['invalid'] = 'Campo inválido ou incompleto';

            if (errorsArray !== undefined) {
                defaultErrorsArray.push.apply(defaultErrorsArray, errorsArray);
            }

            let errorCount = 0;
            if (formElement === undefined) {
                console.warn('Error: form not found');
                return
            }

            this.$el = formElement;

            let form = this.$el;
            let inputs = this.$el.querySelectorAll('input:not(.vs__search)');
            let vSelects = this.$el.querySelectorAll('.v-select');
            let mxDatepicker = this.$el.querySelectorAll('.mx-datepicker');
            let textAreas = this.$el.querySelectorAll('textarea');
            let selects = this.$el.querySelectorAll('select');
            let vueDatePicker = this.$el.querySelectorAll('.b-form-datepicker');

            let fieldsToCheck = [];
                fieldsToCheck.push.apply(fieldsToCheck, inputs);
                fieldsToCheck.push.apply(fieldsToCheck, vSelects);
                fieldsToCheck.push.apply(fieldsToCheck, mxDatepicker);
                fieldsToCheck.push.apply(fieldsToCheck, textAreas);
                fieldsToCheck.push.apply(fieldsToCheck, selects);
                fieldsToCheck.push.apply(fieldsToCheck, vueDatePicker);

            Object.values(fieldsToCheck).forEach((input) => {

                let parentNode = input.parentNode;
                let isValid = true;

                if (parentNode !== null) {
                    let hasInvalidFeedBack = parentNode.querySelector('.invalid-feedback');
                    if (hasInvalidFeedBack === null) {
                        let invalidDIV = document.createElement('div');
                            invalidDIV.className = 'invalid-feedback';
                            parentNode.appendChild(invalidDIV);
                    }
                }

                if (input.required === true) {

                    if (input.value === '' && input.type !== 'radio' && input.type !== 'checkbox') {
                        errorCount++;
                        isValid = false;
                        input.classList.remove('is-valid');
                        input.classList.add('is-invalid');
                        if (parentNode !== null && parentNode.querySelector('.invalid-feedback').innerHTML == "") {
                            parentNode.querySelector('.invalid-feedback').innerHTML = defaultErrorsArray['empty'];
                        }
                    }

                    if( input.value !== '' && input.type !== 'radio' && input.type !== 'checkbox') {
                        input.classList.remove('is-invalid');
                        input.classList.add('is-valid');
                    }

                    if (input.type === 'radio' || input.type === "checkbox") {

                        let inputGroup = this.$el.querySelectorAll('input[name="' + input.name +'"]')
                        let countCheck = 0

                        inputGroup.forEach((i) => {
                            if (i.checked) {
                                countCheck++;
                            }
                        })

                        if (countCheck === 0 ) {
                            errorCount++;
                            isValid = false;
                            inputGroup.forEach((i) => {
                                i.classList.remove('is-valid');
                                i.classList.add('is-invalid');
                            })

                        }
                    }

                }

                if (input.getAttribute('data-confirm') !== null) {
                    let confirReference = document.getElementById(input.getAttribute('data-confirm'));
                    if (confirReference !== null && confirReference.value !== input.value) {
                        errorCount++;
                        isValid = false;
                        if (parentNode !== null && parentNode.querySelector('.invalid-feedback') !== null) {
                            parentNode.querySelector('.invalid-feedback').innerHTML = defaultErrorsArray['missmatch'];
                        }
                    }
                }

                if (input.pattern !== '' && input.pattern !== undefined && input.value !== '') {
                    let reg = new RegExp(input.pattern, "g");
                    if (!reg.test(input.value)) {
                        errorCount++;
                        isValid = false;
                        if (parentNode !== null && parentNode.querySelector('.invalid-feedback') !== null) {
                            parentNode.querySelector('.invalid-feedback').innerHTML = defaultErrorsArray['invalid'];
                        }
                    }
                }

                if (input.type === 'email') {
                    if ((input.value.indexOf('@') === -1 || input.value.indexOf('.') === -1) && input.value !== '') {
                        errorCount++;
                        isValid = false;
                        if (parentNode !== null && parentNode.querySelector('.invalid-feedback') !== null) {
                            parentNode.querySelector('.invalid-feedback').innerHTML = defaultErrorsArray['email'];
                        }
                    }
                }

                if (Object.values(input.classList).indexOf('v-select') !== -1 && input.querySelector('.vs__selected') === null) {

                    errorCount++;
                    isValid = false;
                    input.classList.add('is-invalid');
                    if (parentNode !== null && parentNode.querySelector('.invalid-feedback') !== null) {
                        parentNode.querySelector('.invalid-feedback').innerHTML = defaultErrorsArray['empty'];
                    }

                }

                if (Object.values(input.classList).indexOf('mx-datepicker') !== -1 && input.querySelector('.mx-input').value === '') {

                    errorCount++;
                    isValid = false;
                    input.classList.add('is-invalid');
                    if (parentNode !== null && parentNode.querySelector('.invalid-feedback') !== null) {
                        parentNode.querySelector('.invalid-feedback').innerHTML = defaultErrorsArray['empty'];
                    }

                }

                if (Object.values(input.classList).indexOf('b-form-datepicker') !== -1 && input.querySelector('label').innerHTML === 'No date selected') {

                    errorCount++;
                    isValid = false;
                    input.classList.add('is-invalid');
                    if (parentNode !== null && parentNode.querySelector('.invalid-feedback') !== null) {
                        parentNode.querySelector('.invalid-feedback').innerHTML = defaultErrorsArray['empty'];
                    }

                }

                if (isValid) {
                    input.classList.remove('is-invalid');
                    input.classList.add('is-valid');
                } else {
                    input.classList.remove('is-valid');
                    input.classList.add('is-invalid');
                }

            });


            if (errorCount === 0) {
                console.info('Form Validated, all fields are correct')
                form.classList.add('was-validated');
            } else {
                console.warn('Error found, total count: ' + errorCount);
            }

            return errorCount === 0;
        }

    }



}
